import React from 'react'
import { Trans } from '@lingui/macro'
import { useDispatch, useSelector } from 'react-redux'
import { DotsVerticalIcon } from '@heroicons/react/outline'

import { convertDateToObject, getColor } from 'components/utils'
import { Alert } from 'components/UI/Alert/Alert'
import { IdTicketsState } from 'model/dashboardTickets/dTicketsReducer'
import { ButtonLink } from 'components/UI/ButtonLink/ButtonLink'
import { dTicketsSetDetailItemAC } from 'model/dashboardTickets/dTicketsActionCreators'
import { getColorTickets, getTransStatus, TICKETSTATUS } from 'constants/ticketsStatus'

// Type
export type typeTableHeader = {
    variant?: string

}

// Header data component
export const TableHeader: React.FC<typeTableHeader> = () => {


    return (

        <>

            <th scope="col" className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">
                <Trans>Date</Trans>
            </th>

            <th scope="col" className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">
                <Trans>Title</Trans>
            </th>

            <th scope="col" className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">
                <Trans>Status</Trans>
            </th>

            <th scope="col" className="w-1">
            </th>
        </>

    )
}

// Type
export type typeAction = {
    title: JSX.Element,
    disableSwitcher?: boolean,
    action: ( id: string ) => void,
}

export type typeTableBody = {
    variant?: string
    rowsActions: typeAction[]
    setOpenPopupDetails: React.Dispatch<React.SetStateAction<boolean>>
}

// Body data component
export const TableBody: React.FC<typeTableBody> = ( { variant, rowsActions, setOpenPopupDetails } ) => {

    const color = getColor(variant)

    const dispatch = useDispatch()

    const tableData = useSelector(( state: { dTickets: IdTicketsState } ) => state.dTickets.data)

    const onCellClickHandler = ( e: React.MouseEvent<HTMLTableDataCellElement, MouseEvent>, id: string ) => {
        dispatch(dTicketsSetDetailItemAC(id))
        setOpenPopupDetails(true)
    }

    let component

    if (tableData.length) {
        component = tableData.map(( item, index ) => {

            const statusColor = getColorTickets(item.status)
            const date = item.dateCreated? convertDateToObject(item.dateCreated): ''
            const transStatus = getTransStatus(item.status!)
            const countNewResponse = item.responses!.reduce(( acc, cur ) => cur.viewedByUser === false ? acc + 1 : acc, 0) || 0

            return (
                <tr key={item.id}
                    className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} hover:bg-${color}-50`}>
                    <td className="px-4 py-3 whitespace-nowrap w-1/4 text-sm font-sm text-gray-500 cursor-pointer"
                        onClick={( e ) => onCellClickHandler(e, item.id)}>
                        <div className="flex flex-col">

                            <span className="text-gray-900 font-normal">{date!==''? date.stringDDMMYYYY : ''}</span>
                            <span
                                className="text-gray-500 text-xs leading-4  font-normal">{date!==''? date.stringHHMM : ''}</span>
                        </div>

                    </td>

                    <td className="px-4 py-3 whitespace-wrap break-all text-sm font-normal leading-5 text-gray-900 cursor-pointer"
                        onClick={( e ) => onCellClickHandler(e, item.id)}> {item.name} </td>


                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 cursor-pointer"
                        onClick={( e ) => onCellClickHandler(e, item.id)}>
                        {countNewResponse > 0 ?
                            <div  className="flex "><span className={`bg-yellow-500 rounded w-2 h-2 mr-2 self-center`}/><span className="text-yellow-500"><Trans>New response </Trans>({countNewResponse})</span>
                            </div> : <div className="flex ">
                                <span className={` bg-${statusColor}-400 rounded w-2 h-2 mr-2 self-center`}/><span
                                className={`${(item.viewedBySupport === false && item.status !== TICKETSTATUS.CANCELLED) ? "text-red-400" : "text-gray-500"}`}>{(item.viewedBySupport=== false && item.status !== TICKETSTATUS.CANCELLED) ?
                                <Trans>New</Trans> : transStatus}
                            </span>
                            </div>}
                    </td>


                    <td className="whitespace-nowrap text-sm text-gray-500 pr-2">
                        {item.status === TICKETSTATUS.CANCELLED ? null :
                            <div className="relative flex">
                            <div className=" row-action-block">
                                <DotsVerticalIcon className="row-action-list-open-button h-5 w-5 text-gray-900"/>
                                <div className="row-action-list">
                                    <div className="flex gap-x-4">
                                        {rowsActions.map(( actionItem, ActionIndex ) =>
                                                             <ButtonLink key={ActionIndex}
                                                                         type={'button'}
                                                                         label={actionItem.title}
                                                                         onClick={() => actionItem.action(item.id)}/>)

                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                        }

                    </td>
                </tr>
            )
        })
    } else {
        component = <tr>
            <td className="p-2" colSpan={5}>
                <Alert className="w-full" type={'info'}
                       title={<Trans>The Tickets list is empty. Click Add button to create ticket  or check filters.</Trans>}/>
            </td>
        </tr>
    }

    return (
        <>
            {component}
        </>
    )
}
